import factory from 'state/factory';
import {
  encodePlaylistSeedId,
  getPlaylistIdFromSlug,
} from 'state/Playlist/helpers';
import { formatStationAsset } from 'modules/Analytics/legacyHelpers';

import { getPlaylist, getSeedId } from 'state/Playlist/selectors';
import { requestPlaylist } from 'state/Playlist/actions';

import { getLiveStation } from 'state/Live/selectors';
import { requestSingleStation } from 'state/Live/actions';

const store = factory();

const formatCollectionTopHit = async ({
  catalogId,
  title,
  catalogType,
  url,
}) => {
  if (url) {
    const { id: playlistId, owner: playlistUserId } =
      getPlaylistIdFromSlug(url);

    const seedId = encodePlaylistSeedId(playlistUserId, playlistId);
    const hasPlaylist = getSeedId(store.getState(), { seedId });

    if (!hasPlaylist) {
      await store.dispatch(requestPlaylist({ playlistId, playlistUserId }));
    }

    const playlistData = getPlaylist(store.getState(), { seedId });

    return formatStationAsset({
      id: catalogId,
      name: title,
      type: catalogType,
      playlistData,
    });
  }

  return null;
};

const formatLiveTopHit = async ({ catalogId, title, catalogType }) => {
  await store.dispatch(requestSingleStation(catalogId));

  const station = getLiveStation(store.getState(), { stationId: catalogId });

  return formatStationAsset({
    callLetters: station.callLetters,
    id: catalogId,
    name: title,
    type: catalogType,
  });
};

export const getTopHit = async bestMatch => {
  const topHit = Array.isArray(bestMatch) ? bestMatch[0] : bestMatch;

  const {
    artistId,
    artistName,
    catalogId,
    catalogType,
    contentType,
    id,
    title,
  } = topHit || {};

  const defaultAsset = formatStationAsset({
    artistId,
    artistName,
    callLetters: topHit?.callLetters,
    id: catalogId,
    name: title,
    type: catalogType,
    playlistData: topHit?.playlistData,
  });

  switch (catalogType) {
    case 'collection':
      return (await formatCollectionTopHit(topHit)) || defaultAsset;
    case 'live':
      return formatLiveTopHit(topHit);
    case 'track':
      return formatStationAsset({
        artistId: catalogId,
        artistName: title,
        type: catalogType,
      });
    default:
      return catalogId ? defaultAsset : (
          {
            id: `${contentType}|${id}`,
            name: title || topHit?.name,
          }
        );
  }
};
